export const getStyles = () => ({
  partnersContainer: {
    overflow: "hidden",
  },
  partnersSection: {
    display: "grid",
    position: "relative",
    paddingBlock: "20px",

    "& h2": {
      fontSize: "1.25rem",
      fontWeight: 700,
      textAlign: "center",
      marginBottom: "20px",
    },

    "@media (min-width: 960px)": {
      gridColumn: "2 / -2",
      paddingBlock: "72px",

      "& h2": {
        gridColumn: "1 / -1",
        fontSize: "2.5rem",
      },
    },
  },
  carouselWrapper: {
    width: "100%",
    display: "flex",
    overflowX: "auto",
    cursor: "default",
    userSelect: "none",
    touchAction: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
    mask: "linear-gradient(90deg, transparent, white 10%, white 90%, transparent)",
  },
  carouselContainer: {
    display: "flex",
    gap: "84px",
    paddingRight: "84px",
    justifyContent: "flex-start",
    alignItems: "center",
    userSelect: "none",
    minWidth: "fit-content"
  },
  carouselItem: {
    display: "flex",
    justifyContent: "center",
    paddingBlock: "8px",
    flexShrink: 0,

    "& .partners": {
      maxHeight: "80px",
      width: "auto",
      objectFit: "contain",
    },

    "@media (min-width: 960px)": {
      paddingBlock: "16px",
      "& .partners": {
        maxHeight: "180px",
        width: "auto",
      },
    },
  },
});
